export enum ContractStatus {
  ACTIVE = 'Active',
  VOID = 'Void',
  INACTIVE = 'Inactive',
  APPROVED = 'Approved',
  IN_PROGRESS = 'In Progress',
  IN_REVIEW = 'In Review',
  PENDING_APPROVAL = 'Pending Approval'
}
